import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Edit2, Trash2, Calendar } from "lucide-react";
import { authApi, formatApiError } from "../AuthContext";
import Modal, { ConfirmDialog } from "../Modal";

const empty = { title: "", excerpt: "", body: "", date: "", image_url: "" };

export default function AnnouncementsSection() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const load = () => authApi.get("/admin/announcements").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);
  const onDelete = async () => { await authApi.delete(`/admin/announcements/${confirmDel.id}`); toast.success("Duyuru silindi"); load(); };

  return (
    <div data-testid="admin-announcements">
      <SectionHeader title="Duyurular & Haberler" sub="Yeni duyuru ekle, mevcut haberleri düzenle." onAdd={() => setEditing({ ...empty, date: new Date().toISOString().slice(0,10) })} addLabel="Yeni Duyuru" />
      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} className="card-elev p-5 flex flex-col md:flex-row md:items-center gap-4" data-testid={`admin-announcement-${a.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 text-xs text-muted-foreground mb-1">
                <Calendar className="h-3 w-3 text-primary" />
                {a.date}
              </div>
              <div className="font-display text-lg font-bold uppercase tracking-tight">{a.title}</div>
              <div className="text-sm text-muted-foreground line-clamp-2 mt-1">{a.excerpt}</div>
            </div>
            <div className="flex gap-2 shrink-0">
              <button type="button" onClick={() => setEditing(a)} className="btn-ghost text-xs px-2 py-1.5" data-testid={`announcement-edit-${a.id}`}>
                <Edit2 className="h-3 w-3" /> Düzenle
              </button>
              <button type="button" onClick={() => setConfirmDel(a)} className="btn-ghost text-xs px-2 py-1.5 text-destructive hover:text-destructive" data-testid={`announcement-delete-${a.id}`}>
                <Trash2 className="h-3 w-3" /> Sil
              </button>
            </div>
          </div>
        ))}
      </div>
      {editing && <AnnouncementForm item={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
      <ConfirmDialog open={!!confirmDel} onClose={() => setConfirmDel(null)} onConfirm={onDelete} title="Duyuruyu sil?" body={confirmDel ? `${confirmDel.title} silinecek.` : ""} />
    </div>
  );
}

function AnnouncementForm({ item, onClose, onSaved }) {
  const [form, setForm] = useState(item);
  const [saving, setSaving] = useState(false);
  const isNew = !item.id;
  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (isNew) await authApi.post("/admin/announcements", form);
      else await authApi.put(`/admin/announcements/${form.id}`, form);
      toast.success(isNew ? "Duyuru eklendi" : "Duyuru güncellendi");
      onSaved();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };
  return (
    <Modal open onClose={onClose} title={isNew ? "Yeni Duyuru" : "Duyuruyu Düzenle"} size="lg">
      <form onSubmit={submit} className="space-y-4" data-testid="announcement-form">
        <Field label="Başlık" required><input className="input-base" required value={form.title} onChange={update("title")} data-testid="af-title" /></Field>
        <Field label="Tarih" required><input type="date" className="input-base" required value={form.date} onChange={update("date")} data-testid="af-date" /></Field>
        <Field label="Görsel URL"><input className="input-base" value={form.image_url || ""} onChange={update("image_url")} data-testid="af-image" /></Field>
        <Field label="Özet" required><textarea className="input-base min-h-[60px]" required value={form.excerpt} onChange={update("excerpt")} data-testid="af-excerpt" /></Field>
        <Field label="İçerik" required><textarea className="input-base min-h-[160px]" required value={form.body} onChange={update("body")} data-testid="af-body" /></Field>
        <div className="flex justify-end gap-3 pt-2 border-t border-border">
          <button type="button" onClick={onClose} className="btn-secondary">İptal</button>
          <button type="submit" disabled={saving} className="btn-primary disabled:opacity-60" data-testid="af-submit">{saving ? "Kaydediliyor..." : "Kaydet"}</button>
        </div>
      </form>
    </Modal>
  );
}

function Field({ label, required, children }) {
  return (
    <label className="block">
      <span className="label-input">{label}{required && <span className="text-primary"> *</span>}</span>
      {children}
    </label>
  );
}

function SectionHeader({ title, sub, onAdd, addLabel }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-7">
      <div>
        <h1 className="heading-lg">{title}</h1>
        <p className="text-sm text-muted-foreground mt-1">{sub}</p>
      </div>
      {onAdd && (
        <button type="button" onClick={onAdd} className="btn-primary" data-testid="section-add">
          <Plus className="h-4 w-4" /> {addLabel}
        </button>
      )}
    </div>
  );
}
